import { Component, inject } from '@angular/core';
import { PaywallService } from '../../services/paywall.service';

@Component({
  selector: 'yon-pw-paywall-contact-success',
  standalone: true,
  templateUrl: './paywall-contact-success.component.html',
  styleUrl: './paywall-contact-success.component.scss'
})
export class PaywallContactSuccessComponent {
  public paywallService = inject(PaywallService);
}
